import { UrlConstants } from "../url.constants";
export class ApiBusinessLicenceConstants {
    static URL = UrlConstants.API_V2 + "BusinessLicence";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalBusinessLicenceApplication";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBusinessLicenceApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetBusinessLicenceProperties";
    static FUNCTION_GET_MY_AFLA_INFORMAL_TRADING_APPLICATIONS = "GetBlApplicationsByUser";
    static FUNCTION_GET_APPLICATION_TYPE = "GetBlApplicationTypes";
}
